import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export const getBrandVoiceUrl = brandKitId => {
  const appUrl = getFullUrl('app');
  return `${appUrl}/settings/${PortalIdParser.get()}/account-defaults/branding/brand-kit/${brandKitId || 'primary'}/brand-voice`;
};